import { createEffect, createMemo, on } from "solid-js";

import { getRealPath } from "@/lib/language";
import { checkModalPath } from "@/router/modalRoutes";
import { useLocation } from "@solidjs/router";

import { delaySetCurrentRoute, useRouter } from "./useRouter";

const handlePopState = () => {
  const currentPath = getRealPath(location.pathname);
  if (checkModalPath(currentPath)) {
    delaySetCurrentRoute(currentPath);
  } else {
    delaySetCurrentRoute(null);
  }
};

export const usePopStateHandler = () => {
  const location = useLocation();
  const { getFirstPathSegment } = useRouter();
  createEffect(
    on(
      createMemo(() => location.pathname),
      () => {
        const currentPath = getRealPath(location.pathname);
        if (checkModalPath(getFirstPathSegment(currentPath))) {
          delaySetCurrentRoute(currentPath);
        } else {
          delaySetCurrentRoute(null);
        }
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
      },
    ),
  );
};
